class RegexPatterns {
  static uuid =
    /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/

  static anyString = /[\s\S]*/
}

export { RegexPatterns }
